import React from 'react';

interface PanelProps {
    /** Removes inner padding — use when the panel holds a full-bleed table. */
    flush?: boolean;
    /** Lifts on hover. Only for panels the user can click; static tables should stay put. */
    interactive?: boolean;
    className?: string;
    children: React.ReactNode;
}

/** A white rounded surface. The building block for every page section. */
const Panel: React.FC<PanelProps> = ({ flush, interactive, className = '', children }) => (
    <div
        className={[
            'overflow-hidden rounded-panel border border-line bg-white shadow-panel',
            'transition-all duration-250 ease-smooth',
            flush ? 'p-0' : 'p-4',
            interactive ? 'cursor-pointer hover:-translate-y-0.5 hover:shadow-lifted' : '',
            className,
        ].filter(Boolean).join(' ')}
    >
        {children}
    </div>
);

export default Panel;
